export const SLICE_NAME_USER = 'methodologyChangelogs'
export const FIND_METHODOLOGY_CHANGELOG = 'findMethodologyChangelogs'
export const FIND_CHANGELOG_LOGS = 'findChangelogLogs'
export const FIND_CHANGELOG_PRODUCTS = 'findChangelogProducts'
